import { RouteResponse } from '@pickleballinc/lib/server/next/route/types';
import { useQuery } from '@tanstack/react-query';

import { GetMyLeaguesRes } from '@/modules/league/my-leagues/types';
import { NEXT_PUBLIC_PL_KEY } from '@/modules/league/new-components/constants';
import { getStatesByCountry } from '@/utils/actions/leagues/search/getStatesByCountry';

async function getLeagueStatesByCountry(countryId: string) {
  const response = await getStatesByCountry({ countryId });
  return response.data;
}

export const useGetLeagueStatesByCountry = (countryId: string) => {
  return useQuery({
    queryKey: ['states', countryId],
    queryFn: () => getLeagueStatesByCountry(countryId),
    enabled: countryId !== '',
    refetchOnWindowFocus: false,
    initialData: {
      results: [],
    },
  });
};

export const useGetMyLeagues = (
  leagueType: string | null,
  status: string | null,
  currentPage: number,
  search?: string
) => {
  return useQuery({
    queryKey: ['my_leagues', leagueType, status, currentPage, search],
    queryFn: async () => {
      try {
        const response = await fetch(
          `/api/v1/leagues/myLeagues?pageType=${leagueType}&status=${status}&search=${search}&currentPage=${currentPage}`,
          {
            headers: {
              'X-PL-PUBLIC-KEY': `${NEXT_PUBLIC_PL_KEY}`,
            },
          }
        );
        const result: RouteResponse<GetMyLeaguesRes> = await response.json();

        return result.data;
      } catch {
        return null;
      }
    },
    staleTime: 30 * 1000,
    enabled: !!leagueType && !!status,
  });
};
